import useWindowSize from "app/core/hooks/useWindowSize"
import { useEffect, useState } from "react"
import { ColorBlur } from "./ColorBlur"

export const ResponsiveScale = ({ loaded, children }) => {
  const windowSize = useWindowSize()

  const [scale, setScale] = useState(1)

  useEffect(() => {
    if (windowSize.width == undefined) return

    let newScale = 1.0

    if (windowSize.width < 1400) {
      newScale = Math.max(windowSize.width / 1400)
    }

    setScale(newScale)

    console.log("is loaded!", loaded)
  }, [windowSize, loaded])
  return (
    <div
      style={{
        position: "relative",
        // transform: `scale(${Math.round(scale * 100) / 100})`,
        transformOrigin: "top",
        height: `${Math.round(scale * 742)}px`,
      }}
    >
      <ColorBlur show={loaded} size="xl" />
      <div
        style={{
          transform: `scale(${Math.round(scale * 100) / 100})`,
          transformOrigin: "top",
          height: `${Math.round(scale * 742)}px`,
          zIndex: 1,
        }}
      >
        {children}
      </div>
    </div>
  )
}
